/**
 * 🦸 CAPES
 *
 * Cape equipment items (10 total)
 * Level requirements: 10-80 (increments of ~10)
 * Stat requirements: DEX for agility capes, INT for magical capes
 *
 * Level Distribution:
 * - Common (2): Lv 10, 15
 * - Uncommon (2): Lv 25, 30
 * - Rare (2): Lv 40, 45
 * - Epic (2): Lv 55, 60
 * - Legendary (2): Lv 75, 85
 */

export const CAPES = {
  // ============================================================
  // COMMON CAPES (2) - Lv 10, 15
  // ============================================================
  tatteredCloak: {
    id: 'tatteredCloak',
    name: 'Tattered Cloak',
    icon: '🧥',
    slot: 'cape',
    rarity: 'common',
    levelReq: 10,
    requirements: { DEX: 8 },
    description: 'A worn cloak, full of holes and patches.',
    stats: {
      speed: 0,
      defense: 1,
    },
  },
  woolCape: {
    id: 'woolCape',
    name: 'Wool Cape',
    icon: '🦸',
    slot: 'cape',
    rarity: 'common',
    levelReq: 15,
    requirements: { DEX: 12 },
    description: 'A simple wool cape that keeps you warm.',
    stats: {
      speed: 1,
      defense: 1,
    },
  },

  // ============================================================
  // UNCOMMON CAPES (2) - Lv 25, 30
  // ============================================================
  silkCape: {
    id: 'silkCape',
    name: 'Silk Cape',
    icon: '🦸',
    slot: 'cape',
    rarity: 'uncommon',
    levelReq: 25,
    requirements: { DEX: 40 },
    description: 'A flowing cape made of fine silk.',
    stats: {
      speed: 1,
      defense: 2,
    },
  },
  huntersCloak: {
    id: 'huntersCloak',
    name: "Hunter's Cloak",
    icon: '🧥',
    slot: 'cape',
    rarity: 'uncommon',
    levelReq: 30,
    requirements: { DEX: 48 },
    description: 'A practical cloak favored by hunters.',
    stats: {
      speed: 1,
      defense: 3,
    },
  },

  // ============================================================
  // RARE CAPES (2) - Lv 40, 45
  // ============================================================
  shadowCloak: {
    id: 'shadowCloak',
    name: 'Shadow Cloak',
    icon: '🌑',
    slot: 'cape',
    rarity: 'rare',
    levelReq: 40,
    requirements: { DEX: 75 },
    description: 'A cloak woven from shadows themselves.',
    stats: {
      speed: 2,
      defense: 4,
    },
  },
  featheredMantle: {
    id: 'featheredMantle',
    name: 'Feathered Mantle',
    icon: '🦅',
    slot: 'cape',
    rarity: 'rare',
    levelReq: 45,
    requirements: { DEX: 60, INT: 40 },
    description: 'A majestic mantle adorned with phoenix feathers.',
    stats: {
      speed: 2,
      defense: 5,
    },
  },

  // ============================================================
  // EPIC CAPES (2) - Lv 55, 60
  // ============================================================
  stormcloak: {
    id: 'stormcloak',
    name: 'Stormcloak',
    icon: '⚡',
    slot: 'cape',
    rarity: 'epic',
    levelReq: 55,
    requirements: { DEX: 90, INT: 50 },
    description: 'A cape crackling with lightning energy.',
    stats: {
      speed: 3,
      defense: 7,
      evasion: 0.03,
    },
  },
  phoenixMantle: {
    id: 'phoenixMantle',
    name: 'Phoenix Mantle',
    icon: '🔥',
    slot: 'cape',
    rarity: 'epic',
    levelReq: 60,
    requirements: { INT: 120 },
    description: 'A mantle woven from phoenix fire feathers.',
    stats: {
      speed: 2,
      defense: 8,
      health: 50,
    },
  },

  // ============================================================
  // LEGENDARY CAPES (2) - Lv 75, 85
  // ============================================================
  voidweaver: {
    id: 'voidweaver',
    name: 'Voidweaver',
    icon: '🌌',
    slot: 'cape',
    rarity: 'legendary',
    levelReq: 75,
    requirements: { DEX: 120, INT: 80 },
    description: 'A cape that bends reality around its wearer.',
    stats: {
      speed: 4,
      defense: 10,
      evasion: 0.05,
    },
  },
  cloakOfStars: {
    id: 'cloakOfStars',
    name: 'Cloak of Stars',
    icon: '✨',
    slot: 'cape',
    rarity: 'legendary',
    levelReq: 85,
    requirements: { INT: 170 },
    description: 'Woven from the fabric of the night sky itself.',
    stats: {
      speed: 3,
      defense: 12,
      critChance: 0.08,
    },
  },
};
